import useSWRImmutable from 'swr/immutable';

const fetcher = (url) => fetch(url).then((res) => res.json());

export const useFormData = (id) => {
  const response = useSWRImmutable(`/api/form/${id}`, fetcher);
  return response;
};
